export const COPPER_INCH_PER_OZ = 0.0014;
export const COPPER_MICROETCH_INCH = 0.00015;

export const KILO = 1000;
export const MEGA = KILO * KILO;
export const GIGA = MEGA * KILO;
export const TERA = GIGA * KILO;

export const INCH = {
  name: 'inch',
  symbol: 'in',
  siUnit: 25.4,
  decimals: 4 
}

export const MIL = {
  name: 'mil',
  symbol: 'mil',
  siUnit: 0.0254,
  decimals: 2
}

export const CENTIMETRE = {
  name: 'centimetre',
  symbol: 'cm',
  siUnit: 10,
  decimals: 4
}

export const MILLIMETRE = {
  name: 'millimetre',
  symbol: 'mm',
  siUnit: 1,
  decimals: 3
}

export const MICROMETRE = {
  name: 'micrometre',
  symbol: 'µm',
  siUnit: 0.001,
  decimals: 1
}


export const lengthUnits = [INCH, MIL, CENTIMETRE, MILLIMETRE, MICROMETRE];
export const lengthUnitsMap = lengthUnits.reduce((prev, cur) => {
  prev[cur.name] = cur
  return prev;
}, {});
export const oz2thickness  = (oz) => oz * 20;
export const oz2mil        = (oz) => oz * 1.37;
export const oz2inch       = (oz) => oz2mil(oz) / 1000;
export const inch2mil      = (inch) => inch * 1000;
export const mil2inch      = (mil) => mil / 1000;
export const inch2px       = (inch) => inch * 5000;
export const mhz2label = (mhz) => {
  return mhzToLabel(mhz);
}

export function inch2mm(inch) {
  return inch * INCH.siUnit;
}

export function mm2inch(mm) {
  return mm / INCH.siUnit;
}

export function getLengthUnit(name) {
  return lengthUnitsMap[name] || INCH;
}

export function numberToInch(number, unitName) {
  const unit = getLengthUnit(unitName);
  const millimetre = number * unit.siUnit;
  const inch = mm2inch(millimetre);

  if (isNaN(inch) || number === '') {
    return number;
  }
  return inch;
}

export function inchToNumberUnit(inch, unitName) {
  const unit = getLengthUnit(unitName);
  const millimetre = inch2mm(inch);
  const length = (millimetre / unit.siUnit);
  return {
    value: length,
    unit: unit.symbol,
    decimals: unit.decimals
  };
}


export function inchToString(inch, unitName, withUnit = true, noSpace = true) {
  const { value, unit, decimals } = inchToNumberUnit(inch, unitName)
  const length = value.toFixed(decimals);
  const symbol = withUnit ? unit : '';
  const space = noSpace ? '' : ' ';

  return `${length}${space}${symbol}`;
}

export function copperOz2inch(oz, plating_inch = 0, isOuter = false) {
  const inch = isOuter
    ? COPPER_INCH_PER_OZ * oz + plating_inch
    : COPPER_INCH_PER_OZ * oz + plating_inch - COPPER_MICROETCH_INCH;
    return inch;
}

export function mhzToLabel(mhz) {
  const unitSpacing = 3;
  const units = ['MHz', 'GHz', 'THz', 'PHz'];
  const zeros = Math.floor(Math.log10(mhz));
  const divs = Math.floor(zeros / unitSpacing);
  const displayValue = parseFloat(mhz) / Math.pow(10,(unitSpacing * divs));
  const decimals = displayValue  % 1 !== 0 ? 1 : 0;
  const unit = divs >= units.length ? units[units.length - 1]: units[divs];

  return `${displayValue.toFixed(decimals)} ${unit}`;
}


// WEBPACK FOOTER //
// ./src/lib/unitConversions.js